import "./App.css";
import { useState, useEffect } from "react";
import { onSnapshot, collection, addDoc, Timestamp } from "firebase/firestore";
import db from "./firebase";
import Form from "./components/Form";

function App() {
  const [formData, setFormData] = useState({
    applicationInputs: {},
    contactInputs: {},
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitBtn, setSubmitBtn] = useState(false);

  // useEffect(
  //   () =>
  //     onSnapshot(collection(db, "apps"), (snapshot) => {
  //       console.log(snapshot.docs.map((doc) => doc.data()));
  //     }),
  //   []
  // );

  // const handleNew = async () => {
  //   const collectionRef = collection(db, "apps");
  //   const payload = { key11: "val11", key22: "val22" };
  //   await addDoc(collectionRef, payload);
  // };

  const handleDataSubmission = async () => {
    setLoading(true);

    const collectionRef = collection(db, "apps");
    const payload = formData;
    await addDoc(collectionRef, payload);

    setTimeout(() => {
      window.location.href =
        "https://lookinla.wpengine.com/thank-you-commercial-flow/";
    }, 1500);

    // setLoading(false)
    // setSubmitted(true)
  };

  return (
    <>
      <Form
        formData={formData}
        setFormData={setFormData}
        handleDataSubmission={handleDataSubmission}
        setSubmitBtn={setSubmitBtn}
        loading={loading}
        submitted={submitted}
      />
      {/* <div className="container">
      {loading ? <div className="loading">Loading...</div> : submitted ? <div className="btnText">Submitted!</div> : submitBtn ? <button type="submit" className="btn submitBtn" onClick={handleDataSubmission} loadi>
                    Submit APP
                  </button> : undefined}
      </div> */}
      {/* <div className="App">Hello World</div>
      <button onClick={handleNew}>new</button> */}
    </>
  );
}

export default App;
